module.exports = __webpack_public_path__ + "img/RUN-MIDFOOT-05.3adf3dd0.png";